import useIsCalmSleepApp from '@/hooks/useIsCalmSleepApp';

import useSetupClassicUserAfterAuth from './useSetupClassicUserAfterAuth';
import useSetupSleepUserAfterAuth from './useSetupSleepUserAfterAuth';

// re-export these for components that already know which auth they are for
export { useSetupClassicUserAfterAuth, useSetupSleepUserAfterAuth };

export const useSetupUserAfterAuth = () => {
	const isCalmSleepApp = useIsCalmSleepApp();

	const setupSleepUserAfterAuth = useSetupSleepUserAfterAuth();
	const setupClassicUserAfterAuth = useSetupClassicUserAfterAuth();

	return isCalmSleepApp ? setupSleepUserAfterAuth : setupClassicUserAfterAuth;
};
